import { render, staticRenderFns } from "./goldList.vue?vue&type=template&id=760f3686&scoped=true"
import script from "./goldList.vue?vue&type=script&lang=js"
export * from "./goldList.vue?vue&type=script&lang=js"
import style0 from "./goldList.vue?vue&type=style&index=0&id=760f3686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760f3686",
  null
  
)

export default component.exports